import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import Header from "../Header.js";
import api from "../../api/axios.js";
import useUser from "../../hook/useUser.js"

const formatElapsedTime = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
};

const Quiz = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { user, loading } = useUser();

    const [quiz, setQuiz] = useState(null);
    const [quizIndex, setQuizIndex] = useState(0);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [answerLogs, setAnswerLogs] = useState([]); // true, false, null
    const [elapsedSeconds, setElapsedSeconds] = useState(0);
    const timerRef = useRef(null);

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
  api.get("/api/quizzes/" + id)
       .then((res) => {
        setQuiz(res.data);

        // set all null in the beginning
        const emptyAnswers = new Array(res.data.questions.length).fill(null); 
        setAnswerLogs(emptyAnswers)
        })
        .catch((err) => {
        });
  }, [id]);

  useEffect(() => {
    setElapsedSeconds(0);
    stopTimer();

    timerRef.current = setInterval(() => {
      setElapsedSeconds((prevSeconds) => prevSeconds + 1);
    }, 1000);

    return () => {
      stopTimer();
    };
  }, [id]);

    useEffect(() => {
    setSelectedIndex(null);
    }, [quizIndex]);

    if(!quiz) return <p>Loading...</p>

    const questions = quiz.questions;
    const currentQuestion = questions[quizIndex];
    const lastQuiz = quizIndex === questions.length - 1;

    // click option
    const handleChoose = (index) => {
      setSelectedIndex(index);
    };


    const handleNext = async() => {
      const newLogs = [...answerLogs]; // adding new question answer result in answerLogs array

      if(selectedIndex === null){
        newLogs[quizIndex] = null;
      }else if(selectedIndex + 1 === currentQuestion.correctAnswer){
        newLogs[quizIndex] = true;
      } else{
        newLogs[quizIndex] = false;
      }
      setAnswerLogs(newLogs);

      if(lastQuiz){
        const correctAnswers = newLogs.filter((answer) => answer === true);
        const score = Math.round((correctAnswers.length / questions.length) * 100);
        const result = score >=70 ? "Pass" : "Fail";
        const finalElapsedSeconds = elapsedSeconds;
        const timeSpent = formatElapsedTime(finalElapsedSeconds);
        stopTimer();

        if(loading){
          console.log("User is loading");
          return;
        }

        if(!user || !user.employeeId){
          alert("User information is not loaded.");
          return;
        }

        try {
          const body = {
            employeeId: user.employeeId,
            quizId: quiz._id,
            quizTitle: quiz.title,
            score: score,
            correctNum: correctAnswers.length,
            totalNum: questions.length,
            result: result,
            timeSpent: timeSpent
          };

          await api.post("/api/quiz-result", body);

          console.log("quiz._id:", quiz._id);
          console.log("user.employeeId:", user.employeeId);

          navigate(`/quiz/${id}/${user.employeeId}/result`, {
            state: {
              maxQuizLen: questions.length,
              correctNumLen: correctAnswers.length,
              score: score,
              result: result,
              timeSpent: timeSpent
            }
          });
        } catch(err){
          console.log(err)

  alert("Failed to save quiz result");
        }
        return;
      }

      setQuizIndex(quizIndex + 1);
      
      // display next answer
      // setSelectedIndex(null)
        };
    

      return (
        <>
        <div className="dashboard-wrapper">
          <Header />
           <div className="quiz-top">
             <div onClick={() => navigate(-1)} style={{ cursor: "pointer" }} className="nav_title">
                      <FaChevronLeft className="fa-chevron-left"/>
                      Introduction
              </div>
                  <div id="timer">{formatElapsedTime(elapsedSeconds)}</div>
           </div>
            <div className="quiz_progress_wrapper">
              <div className="quiz_progress">
                {questions.map((q, i) => {
                   const answered = answerLogs[i] === true || answerLogs[i] === false;
                  return(
                    <button key={i} className="progress_btn"
                    style={{background: answered ? "#47111180" : "#FFFDF6",
                            color: answered ? "#FFFDF6" : "#471111",
                            border: `1px solid ${answered ? "#FFFDF6" : "#471111"}`,
                            borderRadius: "8px"
                           }}
                    onClick={() => {
                      setQuizIndex(i);
                      setSelectedIndex(null);
                    }}
                    >
                      {i + 1}
                    </button>
                  );
                })}
              </div>
              <FaChevronRight className="fa-chevron-Right" />
            </div>
            
            <div className="quiz_object">
              <div className="quiz_question">
                <p className="quiz_question_label">Question {quizIndex + 1}</p>
                <div className="quiz_question_box">
                  <p>{currentQuestion.questionText}</p>
                </div>
              </div>

              <div className="quiz_answer">
                {currentQuestion.options.map((o, i) => {
                  const selected = i === selectedIndex;
                  return(
                    <button key={i} 
                    className={selected ? "answer_btn selected" : "answer_btn"}
                    onClick={() => handleChoose(i)}>
                      {o}

                    </button>
                  );
                })}
              </div>
            </div>

                <div className="btn-wrapper">
                     <button type="button" className={selectedIndex !== null ? "next_btn active" : "next_btn"}
                    onClick={handleNext}>
                      {lastQuiz ? "Submit" : "Next"}</button>

                </div>
        </div>

        </>
    );
}

export default Quiz;